import {TimelineLite, TweenLite} from "gsap";


/**
 * Class description
 *
 * Created: 2018-09-06
 * @author jonas
 */
export interface DirtyWildsEnvironmentObject {
    getTransitionToNormal(duration:number):TimelineLite;

    getTransitionToRespin(duration:number):TimelineLite;
}


export class EnvironmentContainer extends PIXI.Container implements DirtyWildsEnvironmentObject {

    constructor(parent:PIXI.Container | null = null) {
        super();
        if(parent) {
            parent.addChild(this);
        }
    }

    public getTransitionToNormal(duration:number):TimelineLite {
        return new TimelineLite();
    }

    public getTransitionToRespin(duration:number):TimelineLite {
        return new TimelineLite();
    }

    public getColorizeAnimation(duration:number, color:string, amount:number):TimelineLite {
        return new TimelineLite();
    }

}